import type * as redux from 'redux';

export interface IOptions {
    isImmutable: (value: {}) => boolean;
    ignore: string[];
}

export interface Immutable {
    (options?: IOptions): redux.Middleware;
}

// This middleware requires a Number.isNaN polyfill to work in IE.
(Number as any).isNaN =
    (Number as any).isNaN ||
    function (value: any): boolean {
        return value !== value; /* NaN is the only value that compares unequal to itself. */
    };

export { default as immutable } from 'redux-immutable-state-invariant';
